<template>
  <div id="consentModal" data-backdrop="static" data-keyboard="false" class="modal modal-position fade" role="dialog">
    <div class="modal-dialog" role="consentModal">
      <div class="modal-content p-0">
        <div class="modal-body pt-50">
          <center>
            <p class="modal-heading">Participant Consent</p>
          </center>
          <div class="row">
            <div class="description pt-8">
              The participant’s informed consent hasn't <br />
              been completed yet.
            </div>
          </div>
          <div class="row">
            <div class="description pt-15">
              It is recommended that this process be complete prior to <br />
              starting the study for the participant.
            </div>
          </div>
          <div class="row download-modal pt-20 pb-35 text-center">
            <div class="schedule-buttons">
              <button class="btn add-invite-btn mr-18 br-4 pt-7 pb-7 pl-34 pr-34 trigger-day-btn btn-scheduled" @click="closeConsentModal()">
                Cancel
              </button>
              <button class="btn br-4 pt-7 pb-7 pl-63 pr-63 trigger-day-btn confirm" @click="triggerDayZeroPopup">
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showConsentModal: {
      type: Boolean
    }
  },
  watch: {
    showConsentModal() {
      if (this.showConsentModal) {
        window.$("#consentModal").modal("show");
      } else {
        window.$("#consentModal").modal("hide");
      }
    }
  },
  methods: {
    triggerDayZeroPopup() {
      window.$("#consentModal").modal("hide");
      this.$emit("triggerDayZeroPopup");
      this.$emit("cancelButtonClicked", false);
    },
    closeConsentModal() {
      this.$emit("cancelButtonClicked", false);
    }
  }
};
</script>

<style scoped lang="scss">
#consentModal {
  .modal-dialog {
    width: 500px;

    .modal-body {
      .invite-text {
        width: 100%;
        color: #666669;
        font-size: 18px;
        font-family: Roboto-Bold;
      }

      .download-modal {
        width: 100%;
        display: inline-block;
      }

      .btn-close {
        position: absolute;
        right: 11px;
        top: 10px;
        width: 12px;
        height: 12px;
        cursor: pointer !important;
        color: #fff;
        z-index: 999999;
      }

      .btn-close:hover {
        opacity: 0.3;
      }

      .btn-close:before,
      .btn-close:after {
        position: absolute;
        left: 7px;
        content: " ";
        height: 11px;
        width: 2.5px;
        background-color: #666669;
      }

      .btn-close:before {
        transform: rotate(45deg);
      }

      .btn-close:after {
        transform: rotate(-45deg);
      }
    }
  }

  .trigger-day-btn {
    border-radius: 100px;

    &.cancel:hover {
      box-shadow: none;
    }

    &.confirm {
      background-color: #4c8ce4 !important;
      border-color: #4c8ce4 !important;
      color: #fff;
    }

    &.btn-scheduled {
      background-color: #e0e0e0;
      color: #000000;
    }
  }

  .schedule-buttons {
    button {
      font-size: 14px !important;
    }
  }

  .modal-heading {
    font-family: Roboto-Regular;
    font-size: 19px;
    font-weight: bold;
    color: #666669;
  }

  .description {
    font-family: Roboto-Regular;
    font-size: 15px;
    padding: 15px 20px;
    text-align: center;
    color: #666669;
    margin: auto;
  }
}
</style>
